import React from "react";
import { NotificationManager } from "react-notifications";

import { userManager } from "lib/auth.config";
import { devAuthManager, isUsingKeycloak } from "lib/auth.config";
import IntlMessages from "./IntlMessages";
import { routes } from "./routes";

const LOGOUT_REDIRECT_URI_PARAM = "redirect_to";

export async function initiateLogout() {
  try {
    const postLogoutRedirectUri = `${routes.authentication.logout()}?${LOGOUT_REDIRECT_URI_PARAM}=${
      window.location.href
    }`;
    if (isUsingKeycloak) {
      await userManager.signoutRedirect({
        post_logout_redirect_uri: postLogoutRedirectUri,
      });
    } else {
      await devAuthManager.signoutRedirect();
    }
  } catch (error) {
    console.error("Logout error:", error);
    NotificationManager.error(<IntlMessages id="DIC_LOGOUT_ERROR_MESSAGE" />);
  }
}
